import React from 'react';
import styled from 'styled-components';

const Card = styled.div<{
  $backgroundColor?: string;
  $borderColor?: string;
  $color?: string;
}>`
  padding: 8px 12px;
  background-color: ${props => props.$backgroundColor || '#e7f3ff'};
  border-left: 3px solid ${props => props.$borderColor || '#0066cc'};
  border-radius: 4px;
  font-size: 13px;
  color: ${props => props.$color || '#004085'};
  display: flex;
  align-items: center;
  gap: 6px;
`;

type Props = {
  children: React.ReactNode;
  backgroundColor?: string;
  borderColor?: string;
  color?: string;
};

const ModuloCard: React.FC<Props> = ({
  children,
  backgroundColor,
  borderColor,
  color
}) => {
  return (
    <Card
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      $color={color}
    >
      {children}
    </Card>
  );
};

export default ModuloCard;
